export default __webpack_public_path__ + "static/media/breakfast6.098a61e0.png";